module.exports = __webpack_public_path__ + "static/img/14.fb080922.png";